
import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="bg-blue-600 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-center sm:justify-end items-center gap-4 sm:gap-8 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-blue-200"></i>
              <a href="tel:01634753454" className="hover:text-blue-200 transition-colors cursor-pointer">
                01634 753454
              </a>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-blue-200"></i>
              <a href="mailto:Info@Cbnaccounting.co.uk" className="hover:text-blue-200 transition-colors cursor-pointer">
                Info@Cbnaccounting.co.uk
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                  <i className="ri-calculator-line text-white text-xl"></i>
                </div>
                <span className="text-2xl font-bold text-gray-900">CBN ACCOUNTING LIMITED</span>
              </div>
            </div>

            <div className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Home
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Services
              </button>
              <button onClick={() => scrollToSection('why-us')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Why Choose Us
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                Contact Us
              </button>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
            </button>
          </div>

          {isMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="flex flex-col gap-4">
                <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                  Home
                </button>
                <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                  Services
                </button>
                <button onClick={() => scrollToSection('why-us')} className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                  Why Choose Us
                </button>
                <button onClick={() => scrollToSection('contact')} className="bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-colors text-center cursor-pointer whitespace-nowrap">
                  Contact Us
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
